import { INSTAGRAM_CONTENT_TYPES } from '~/constants';

export enum CONTENT_SEARCH_ROSTER {
  agency = 'agency',
  myTalent = 'self',
}

export enum CONTENT_SEARCH_PARAMS {
  ads = 'ads',
  channel = 'channel',
  creator = 'creator',
  page = 'page',
  page_size = 'page_size',
  platform = 'platform',
  query = 'query',
  roster = 'roster',
  sort = 'sort',
  sortBy = 'sortBy',
  view = 'view',
  fuzzy = 'fuzzy',
  autoCompleteQuery = 'autoCompleteQuery',
  postedAfter = 'postedAfter',
  postedBefore = 'postedBefore',
}

export const CONTENT_SEARCH_CHANNEL = {
  [INSTAGRAM_CONTENT_TYPES.post]: 'FEED',
  [INSTAGRAM_CONTENT_TYPES.story]: 'STORY',
  [INSTAGRAM_CONTENT_TYPES.reels]: 'REELS',
} as const;

export enum CONTENT_SEARCH_ORDER_BY {
  commentCount = 'comment_count',
  likeCount = 'like_count',
  publishedAt = 'published_at',
  revelance = 'relevance',
  shareCount = 'share_count',
  sharedViewCount = 'shared_view_count',

  // Instagram
  exitCount = 'exit_count',
  interactionCount = 'interaction_count',
  postFollowersEngRate = 'post_followers_eng_rate',
  postReachEngRate = 'post_reach_eng_rate',
  reachCount = 'reach_count',
  replyCount = 'reply_count',
  savedCount = 'saved_count',
  storyFollowersReachRate = 'story_followers_reach_rate',
  swipeUpCount = 'swipe_up_count',
  tapsBackCount = 'taps_back_count',
  tapsForwardCount = 'taps_forward_count',
  videoReachViewRate = 'video_reach_view_rate',
  videoViewCount = 'video_view_count',
  viewsCount = 'views', // New field from Meta Graph API V22

  // TikTok
  followerEngRate = 'follower_engagement_rate',

  // Instagram and Tiktok
  engagementCount = 'engagement_count',
  followerCount = 'follower_count',

  // TikTok and YouTube
  engagementRate = 'engagement_rate',
  viewCount = 'view_count',

  // YouTube
  dislikeCount = 'dislike_count',
  duration = 'duration',
  favoriteCount = 'favorite_count',
  subscriberCount = 'subscriber_count',
  viewRate = 'view_rate',
}

export const CONTENT_SEARCH_ORDER_BY_NAMES = {
  [CONTENT_SEARCH_ORDER_BY.commentCount]: 'Comments',
  [CONTENT_SEARCH_ORDER_BY.publishedAt]: 'Most Recent',
  [CONTENT_SEARCH_ORDER_BY.likeCount]: 'Likes',
  [CONTENT_SEARCH_ORDER_BY.revelance]: 'Relevance',
  [CONTENT_SEARCH_ORDER_BY.shareCount]: 'Shares',
  [CONTENT_SEARCH_ORDER_BY.sharedViewCount]: 'Shared views',

  // Instagram
  [CONTENT_SEARCH_ORDER_BY.exitCount]: 'Exit',
  [CONTENT_SEARCH_ORDER_BY.interactionCount]: 'Interactions',
  [CONTENT_SEARCH_ORDER_BY.postFollowersEngRate]: 'Follower Engagement Rate',
  [CONTENT_SEARCH_ORDER_BY.postReachEngRate]: 'Reach Engagement Rate',
  [CONTENT_SEARCH_ORDER_BY.reachCount]: 'Reach',
  [CONTENT_SEARCH_ORDER_BY.replyCount]: 'Replies',
  [CONTENT_SEARCH_ORDER_BY.savedCount]: 'Saves',
  [CONTENT_SEARCH_ORDER_BY.storyFollowersReachRate]:
    'Followers Engagement Rate',
  [CONTENT_SEARCH_ORDER_BY.swipeUpCount]: 'Swipe up',
  [CONTENT_SEARCH_ORDER_BY.tapsBackCount]: 'Taps back',
  [CONTENT_SEARCH_ORDER_BY.tapsForwardCount]: 'Taps forward',
  [CONTENT_SEARCH_ORDER_BY.videoReachViewRate]: 'Reach View Rate',
  [CONTENT_SEARCH_ORDER_BY.videoViewCount]: 'View Count',
  [CONTENT_SEARCH_ORDER_BY.viewsCount]: 'Views',

  // TikTok
  [CONTENT_SEARCH_ORDER_BY.followerEngRate]: 'Followers Engagement Rate',
  // Instagram and Tiktok
  [CONTENT_SEARCH_ORDER_BY.engagementCount]: 'Engagements',
  [CONTENT_SEARCH_ORDER_BY.followerCount]: 'Followers',

  // TikTok and YouTube
  [CONTENT_SEARCH_ORDER_BY.engagementRate]: 'Engagements',
  [CONTENT_SEARCH_ORDER_BY.viewCount]: 'Views',

  // YouTube
  [CONTENT_SEARCH_ORDER_BY.dislikeCount]: 'Dislikes',
  [CONTENT_SEARCH_ORDER_BY.duration]: 'Duration',
  [CONTENT_SEARCH_ORDER_BY.favoriteCount]: 'Favorites',
  [CONTENT_SEARCH_ORDER_BY.subscriberCount]: 'Subcribers',
  [CONTENT_SEARCH_ORDER_BY.viewRate]: 'Average View Percentage',
} as const;

export const CONTENT_SEARCH_DEFAULT_ORDER_BY = [
  CONTENT_SEARCH_ORDER_BY.commentCount,
  CONTENT_SEARCH_ORDER_BY.likeCount,
  CONTENT_SEARCH_ORDER_BY.publishedAt,
];

export const CONTENT_SEARCH_INSTAGRAM_ORDER_BY = [
  ...CONTENT_SEARCH_DEFAULT_ORDER_BY,
  CONTENT_SEARCH_ORDER_BY.viewsCount,
  CONTENT_SEARCH_ORDER_BY.engagementCount,
  CONTENT_SEARCH_ORDER_BY.postFollowersEngRate,
  CONTENT_SEARCH_ORDER_BY.reachCount,
  CONTENT_SEARCH_ORDER_BY.postReachEngRate,
  CONTENT_SEARCH_ORDER_BY.savedCount,
];

export const CONTENT_SEARCH_INSTAGRAM_POST_ORDER_BY = [
  ...CONTENT_SEARCH_DEFAULT_ORDER_BY,
  CONTENT_SEARCH_ORDER_BY.engagementCount,
  CONTENT_SEARCH_ORDER_BY.postFollowersEngRate,
  CONTENT_SEARCH_ORDER_BY.viewsCount,
  CONTENT_SEARCH_ORDER_BY.reachCount,
  CONTENT_SEARCH_ORDER_BY.postReachEngRate,
  CONTENT_SEARCH_ORDER_BY.savedCount,
  CONTENT_SEARCH_ORDER_BY.shareCount,
];

export const CONTENT_SEARCH_INSTAGRAM_STORY_ORDER_BY = [
  CONTENT_SEARCH_ORDER_BY.viewsCount,
  CONTENT_SEARCH_ORDER_BY.publishedAt,
  CONTENT_SEARCH_ORDER_BY.reachCount,
  CONTENT_SEARCH_ORDER_BY.replyCount,
  CONTENT_SEARCH_ORDER_BY.shareCount,
];

export const CONTENT_SEARCH_INSTAGRAM_REEL_ORDER_BY = [
  ...CONTENT_SEARCH_DEFAULT_ORDER_BY,
  CONTENT_SEARCH_ORDER_BY.engagementCount,
  CONTENT_SEARCH_ORDER_BY.postFollowersEngRate,
  CONTENT_SEARCH_ORDER_BY.viewsCount,
  CONTENT_SEARCH_ORDER_BY.reachCount,
  CONTENT_SEARCH_ORDER_BY.postReachEngRate,
  CONTENT_SEARCH_ORDER_BY.savedCount,
];

export const CONTENT_SEARCH_TIKTOK_ORDER_BY = [
  ...CONTENT_SEARCH_DEFAULT_ORDER_BY,
  CONTENT_SEARCH_ORDER_BY.viewCount,
  CONTENT_SEARCH_ORDER_BY.engagementRate,
];

export const CONTENT_SEARCH_YOUTUBE_ORDER_BY = [
  ...CONTENT_SEARCH_DEFAULT_ORDER_BY,
  CONTENT_SEARCH_ORDER_BY.viewCount,
  CONTENT_SEARCH_ORDER_BY.shareCount,
];

export const CONTENT_SEARCH_AD_HASHTAGS = [
  '#sponsored',
  '#gifted',
  '#ad',
  '#advertisement',
  '#partnership',
  '#anzeige',
  '#reklame',
  '#spon',
  '#sp',
  '#partner',
  '#paid',
  '#publicidade',
  '#ambassador',
  '#publi',
  '#paidpartnership',
  '#werbung',
];
